import { render } from "./CFAVideo.vue?vue&type=template&id=347482b0&scoped=true"
import script from "./CFAVideo.vue?vue&type=script&lang=js"
export * from "./CFAVideo.vue?vue&type=script&lang=js"

import "./CFAVideo.vue?vue&type=style&index=0&id=347482b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-347482b0"]])

export default __exports__